import { Selector } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { MenuPanelItemId } from "../../panelItems";
import { getActiveSectionId, getPanelItem } from "../../selectors";
import { MenuPanelItemType, SectionId } from "../../types";
import { FormMenu } from "../FormMenu";
import { NotificationMenu } from "../NotificationMenu";
import { QuickAccessMenu } from "../QuickAccessMenu";
import { UserMenu } from "../UserMenu";

export type MenuComponent = typeof FormMenu | typeof UserMenu | typeof NotificationMenu | typeof QuickAccessMenu;

/**
 * Získá komponentu sekce menu. Vrací undefined, pokud nemá aktivní sekce svoji komponentu.
 * @param state
 */
export const getSectionComponent: Selector<IAppState, MenuComponent | undefined> = (state) => {
    const activeSectionId = getActiveSectionId(state);

    const activePanelItem = getPanelItem(state, activeSectionId);
    if (!activePanelItem) {
        return undefined;
    }

    switch (activePanelItem.type) {
        case MenuPanelItemType.notificationGroup:
            return NotificationMenu;
        case MenuPanelItemType.form:
            return FormMenu;
        default:
            return menuComponentsMap.get(activeSectionId);
    }
};

/**
 * Mapa pro výběr komponenty pro aktivní sekci menu podle aktivního id sekce.
 */
export const menuComponentsMap: Map<SectionId, MenuComponent> = new Map([
    // QuickAccessMenu vyžaduje přetypování, jinak nastává chyba TS2769 s dlouhým popisem, kdo se více vyzná v TypeScriptu, může zkusit vyřešit.
    [MenuPanelItemId.quickAccess, QuickAccessMenu] as [SectionId, MenuComponent],
    [MenuPanelItemId.user, UserMenu],
]);
